import { ff } from '@atlassian/jira-feature-flagging';
import { fg } from '@atlassian/jira-feature-gating';
import { staticSidebarDefaultPINFiltersResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/project-filters/index.tsx';
import { sidebarProjectIssuesResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/project-sidebar-common/index.tsx';
import { getBusinessProjectResources } from '@atlassian/jira-router-resources-business-common';
import { isNinGlobalScopeEnrolmentEnabledResource } from '@atlassian/jira-router-resources-is-nin-global-scope-enrolment-enabled';
import {
	issueNavigatorRelayResource,
	issueNavigatorFilterRelayResource,
	issueNavigatorHydrationRelayResource,
} from '@atlassian/jira-router-resources-issue-navigator';
import {
	getNavigationResources,
	getNavigationSidebarProjectResource,
} from '@atlassian/jira-router-resources-navigation';
import {
	resourceWithCondition,
	resourceWithCondition2,
} from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';

export const getCommonProjectResources = () => [
	issueNavigatorRelayResource,
	issueNavigatorFilterRelayResource,
	resourceWithCondition2(
		() => fg('nin_request_hydrate_query_earlier'),
		issueNavigatorHydrationRelayResource,
	),
	...getNavigationResources(),
	...getNavigationSidebarProjectResource(),
	...getBusinessProjectResources(),
	resourceWithCondition(() => ff('nin.global-scope_aqec8'), sidebarProjectIssuesResource),
	resourceWithCondition2(
		() => ff('nin.global-scope_aqec8'),
		isNinGlobalScopeEnrolmentEnabledResource,
	),
	// this resource is also used by the nav4 sidebar for JSM project's 'issues and filters'
	// src/packages/navigation-apps/sidebar-nav4/jsm-project-menu/src/ui/project-menu/issues-and-filters/default-filters/index.tsx
	staticSidebarDefaultPINFiltersResource,
];
